import SyncMySchedule from "./SyncMySchedule";

export default SyncMySchedule;
